import type { AnteprimaExcel } from "../../api/utentiCassaforte";

/** C'è qualcosa da scrivere: utenze nuove o modificate, conti, accredito, o assenti spuntate. */
export function excelDaApplicare(anteprima: AnteprimaExcel, rimuovi: ReadonlySet<string>): boolean {
  return (
    rimuovi.size > 0 ||
    anteprima.fogli.some((f) => f.nuove.length > 0 || f.modificate.length > 0 || f.conti_tecnici.length > 0 || !!f.accredito)
  );
}

/** «Conferma e applica» si accende solo senza errori (impronta presente) e con qualcosa da scrivere. */
export function excelConfermabile(anteprima: AnteprimaExcel | null, rimuovi: ReadonlySet<string>): boolean {
  return !!anteprima?.impronta && excelDaApplicare(anteprima, rimuovi);
}
